import { Styles } from '@monkvision/types';

export const styles: Styles = {
  wrapper: {
    width: '100%',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'start',
    gap: '30px',
    marginTop: '80px',
  },
  arrowsContainer: {
    width: '450px',
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'space-around',
  },
  vehicle360: {
    height: '300px',
  },
};
